import AxiosInstance from "../services/networkServices";

// Admin-panel accounts (restricted admin sub-accounts). Full admins only.

export const listAdminAccounts = () => AxiosInstance.get(`/admin/admin-accounts`);

/** { username, email?, firstName?, lastName?, password?, permissions[] } */
export const createAdminAccount = (data) =>
  AxiosInstance.post(`/admin/admin-accounts`, data);

/** Any of { username, email, firstName, lastName, permissions, isDisabled } */
export const updateAdminAccount = (id, data) =>
  AxiosInstance.put(`/admin/admin-accounts/${id}`, data);

/** { password? } — omit to have the server generate one */
export const resetAdminAccountPassword = (id, data = {}) =>
  AxiosInstance.post(`/admin/admin-accounts/${id}/reset-password`, data);

export const deleteAdminAccount = (id) =>
  AxiosInstance.delete(`/admin/admin-accounts/${id}`);
